import { render, staticRenderFns } from "./ProjectResumePage.vue?vue&type=template&id=8c4c426e&scoped=true&"
import script from "./ProjectResumePage.vue?vue&type=script&lang=js&"
export * from "./ProjectResumePage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectResumePage.vue?vue&type=style&index=0&id=8c4c426e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c426e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
